import { render } from "./LongTextType.vue?vue&type=template&id=21245d3e"
import script from "./LongTextType.vue?vue&type=script&lang=js"
export * from "./LongTextType.vue?vue&type=script&lang=js"

import exportComponent from "/Users/biwabits/Documents/ProjectDev/yayasan-ahmadyanibinjai/form-ppdb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__